import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { type CreateMatrix } from '../types/types'
import { useAuth } from './useAuth'
import { throwOnError } from '../utils/throwOnError'

export const useGetMatricesQuery = (isEnabled = true) => {
  const { authFetch } = useAuth()
  return useQuery({
    queryKey: ['matrices'],
    enabled: isEnabled,
    queryFn: async () => {
      const { data, error } = await authFetch().GET('/matrices')
      if (error) {
        throwOnError(error)
      }
      return data
    }
  })
}

export const useCreateMatrixMutation = () => {
  const queryClient = useQueryClient()
  const { authFetch } = useAuth()
  return useMutation({
    mutationFn: async (matrix: CreateMatrix) => {
      const { data, error } = await authFetch().POST('/matrices', {
        body: matrix
      })
      if (error) {
        throwOnError(error)
      }
      return data
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['matrices']
      })
    }
  })
}

export const useDeleteMatrixMutation = () => {
  const queryClient = useQueryClient()
  const { authFetch } = useAuth()
  return useMutation({
    mutationFn: async (matrixId: number) =>
      await authFetch().DELETE('/matrices/{matrixId}', {
        params: {
          path: { matrixId }
        }
      }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['matrices']
      })
    }
  })
}
